require('../../modules/es.string.small');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'small');
